import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDroneComponent } from './simple-icons-drone.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDroneComponent ],
    exports:      [ SimpleIconsDroneComponent ],
    bootstrap:    []
})
export class SimpleIconsDroneModule {}
